import { backendRequest } from 'services/request'

export function getCurrentUser() {
  return backendRequest({
    url: '/users/me',
    method: 'get'
  })
}
